import PropTypes from 'prop-types'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { toastErrorLog } from '../../helpers/toastErrorLog.js'
import { useAuth } from '../../hooks/useAuth'
import { Checkbox } from '../reutilizables/checkbox/Checkbox'
import { VincularMercadoPago } from '../reutilizables/pasarelaPagos/VincularMercadoPago.jsx'
import * as empresaService from '../servicios/empresaService'
import { ModalContenidoTerminos } from '../terminos/ModalContenidoTerminos.jsx'
//import LinkButton from '../ui/LinkButton'
import DatosFiscales from './DatosFiscales.jsx'
import DatosPersonales from './DatosPersonales'
import Domicilios from './Domicilios.jsx'
import Hero from './Hero'
import styles from './Perfil.module.css'

const Perfil = ({ cambiarImagenPerfil }) => {
  const {
    loginDataContext: { empid, emiteFacturaA } = {},
    updateUserData,
    esPerfilAdmin
  } = useAuth()
  const [mostrarContenido, setMostrarContenido] = useState(false)

  const handleClick = () => {
    setMostrarContenido(true)
  }

  const actualizarDatos = async (emiteFacturaA) => {
    try {
      const body = { empId: empid, emiteFacturaA }
      await empresaService.actualizarEmpresa(body)
      updateUserData({ emiteFacturaA })
      toast.success('Datos actualizados correctamente')
    } catch (error) {
      const mensaje = 'Error al actualizar Factura A'
      toastErrorLog(error, mensaje, 'empresa')
    }
  }

  return (
    <div className="pageCard pageCard--conMargenInferior">
      <Hero cambiarImagenPerfil={cambiarImagenPerfil} />
      <DatosPersonales />

      <div className={styles.pairedGrid}>
        <div className={styles.pairedCheckbox}>
          <div className={styles.card}>
            <h3 className={styles.cardTitle}>Términos y Condiciones</h3>
            <div className={styles.termsRow}>
              <Checkbox
                type="checkbox"
                name="aceptaTyC"
                label=" "
                checked={true}
                disabled
                className="mt-1"
              />
              <button onClick={handleClick} className="btn btn-link p-0 align-baseline">
                Ver los términos y condiciones de venta de e-BuyMarket
              </button>
            </div>
          </div>
          <div className={styles.card}>
            <h3 className={styles.cardTitle}>Factura A</h3>
            <div className={`${styles.termsRow} ${styles['termsRow--columna']}`}>
              <Checkbox
                type="checkbox"
                name="emiteFacturaA"
                label="Emite Factura A"
                checked={emiteFacturaA}
                disabled={!esPerfilAdmin}
                className="mt-1"
                onChange={() => actualizarDatos(!emiteFacturaA)}
              />
              <span className={styles.termsSubtitulo}>
                Esta información se podrá observar en el detalle de cada publicación
              </span>
            </div>
          </div>
        </div>
        <VincularMercadoPago empid={empid} />
      </div>

      <div className={`${styles.pairedGrid} ${styles.pairedGridScroll}`}>
        <DatosFiscales />
        <Domicilios />
      </div>

      {/*<div className={styles.sectionsGrid}>
        <div className={styles.card}>
          <h3 className={styles.cardTitle}>Seguridad</h3>
          {tipoUsuario === 'R' ? (
            <LinkButton className="btn btn-sign-in" to={'/Password'}>
              Cambiar mi contraseña
            </LinkButton>
          ) : (
            <p className={styles.emptyState}>
              Tu cuenta es de tipo Empresa. Para cambiar tu contraseña tenés que hacerlo desde
              <a href="https://e-buyplace.com"> aquí</a>
            </p>
          )}
        </div>
      </div>*/}

      <ModalContenidoTerminos
        show={mostrarContenido}
        onCerrar={() => setMostrarContenido(false)}
        soloLectura
      />
    </div>
  )
}

Perfil.propTypes = {
  cambiarImagenPerfil: PropTypes.func.isRequired
}

export default Perfil
